import { CHANGE_TELEGRAM } from "app/api/redux/Chat/actions/changeTelegram";
import getUserOptions from "app/api/requests/Chat/getUserOptions";
import getChatToken from "app/api/getChatToken";

export const getTelegramName = () => (dispatch: any): any => {
	const token = getChatToken();
	return getUserOptions(token).then(options => {
		dispatch({ type: CHANGE_TELEGRAM, payload: options.telegramName ?? '' });
	})
}
